export default __webpack_public_path__ + "static/media/teenagers-group.25d2655d.png";